import { useEffect, useState } from 'react';
import { Theme, THEME_ORDER } from '@/components/login-theme';

// 学生端主题（橙/绿/蓝/粉）以 <html data-theme> 承载，ThemeSelector 写入并持久化到 localStorage。
// 手机横屏舞台复用同一机制：读取用 MutationObserver 响应式跟随，写入调 setThemeAttr。

export function readThemeAttr(): Theme {
  if (typeof document === 'undefined') return 'orange';
  const t = document.documentElement.getAttribute('data-theme') as Theme | null;
  return t && THEME_ORDER.includes(t) ? t : 'orange';
}

export function setThemeAttr(t: Theme): void {
  document.documentElement.setAttribute('data-theme', t);
  try {
    window.localStorage.setItem('eeelt_theme', t);
  } catch {
    /* ignore storage errors */
  }
}

export function useThemeAttr(): Theme {
  const [theme, setTheme] = useState<Theme>(readThemeAttr);
  useEffect(() => {
    const obs = new MutationObserver(() => setTheme(readThemeAttr()));
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => obs.disconnect();
  }, []);
  return theme;
}
